import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { cloudPrepApi } from '../../../services/cloudPrepApi';

import { TestInstance } from './types';

export type AssignedTest = {
  cloudPrepTestDTO: any;
  testName: string;
  testStatus: 'NOT_YET' | 'STARTED' | 'COMPLETED';
  userId: string;
  id: string;
  userTestId: string;
  testSetId: string;
  testType?: string;
  answers?: Record<
    string,
    {
      answerOption: string;
      answerValue: string;
      correctAnswer: boolean;
      active?: boolean;
    }[]
  >;
};

export type AssignedTests = {
  assignedTests: number;
  totaltests: number;
  data: AssignedTest[];
};

export type CloudPrepState = {
  currentTab: 'overView' | 'aiTests' | 'results';
  openCard: string | null;
  selectedCloud: string | null;
  assignedTests: AssignedTests;
  isInstructions: boolean;
  selectedTestData: AssignedTest | null;
  testData: TestInstance;
};

const initialState: CloudPrepState = {
  currentTab: 'overView',
  openCard: null,
  selectedCloud: 'AMAZON_WEB_SERVICES',
  assignedTests: {} as AssignedTests,
  isInstructions: false,
  selectedTestData: null,
  testData: {} as TestInstance
};

const cloudPrepSlice = createSlice({
  name: 'cloudPrep',
  initialState,

  reducers: {
    setOpenCard: (state, action: PayloadAction<string | null>) => {
      state.openCard = action.payload;
    },

    setCurrentTab: (
      state,
      action: PayloadAction<'overView' | 'aiTests' | 'results'>
    ) => {
      state.currentTab = action.payload;
    },

    setSelectedCloud: (state, action: PayloadAction<string | null>) => {
      state.selectedCloud = action.payload;
    },

    setIsInstructions: (state, action: PayloadAction<boolean>) => {
      state.isInstructions = action.payload;
    },

    setSelectedTestData: (
      state,
      action: PayloadAction<AssignedTest | null>
    ) => {
      state.selectedTestData = action.payload;
    },

    resetCloudPrepState: () => initialState
  },

  extraReducers: builder => {
    builder.addMatcher(
      cloudPrepApi.endpoints.getAssignedTests.matchFulfilled,
      (state, action) => {
        state.assignedTests = action.payload;
      }
    );

    builder.addMatcher(
      cloudPrepApi.endpoints.startCloudPrepTest.matchFulfilled,
      (state, action) => {
        // Ensure data is mapped correctly
        state.testData = action.payload?.data || action.payload;
      }
    );

    builder.addMatcher(
      cloudPrepApi.endpoints.resumeCloudPrepTest.matchFulfilled,
      (state, action) => {
        // FIX: Ensuring testData is populated properly to avoid blank screens
        state.testData = action.payload?.data || action.payload;
      }
    );
  }
});

export const {
  setCurrentTab,
  setOpenCard,
  setSelectedCloud,
  setIsInstructions,
  setSelectedTestData,
  resetCloudPrepState
} = cloudPrepSlice.actions;

export default cloudPrepSlice.reducer;
